<template>
  <div class="soundSet-pane" @keydown.stop>
    <div class="tabTitle">
      <p>配乐设置</p>
    </div>
    <div class="soundtrack-container" v-if="getSelectMusic">
      <div class="soundtrack-item">
        <div class="soundtrack-item-loop" @click="loopSoundTrack">
          一键循环配乐
        </div>
        <div class="soundtrack-item-name">
          <span class="current-music-title">{{ getSelectMusic.title }}</span>
          <p @click="favoriteItem(getSelectMusic)" class="collection">
            <span class="iconfont iconshoucang1"> </span>

            <!-- :class="[favoritesState ? 'iconyishoucang' : 'iconshoucang']" -->
            收藏
          </p>
        </div>
        <div class="soundtrack-operate">
          <div class="play-shell">
            <div
              class="play-btn iconfont"
              :class="[musics.isPlay ? 'play-btn-pause' : 'play-btn-play']"
              @click="musicPlaySet"
            ></div>
          </div>
          <div class="soundtrack-bar" style="height: 100%">
            <audio
              ref="audioSet"
              :src="$handleAssetsUrl(getSelectMusic.url)"
              @loadedmetadata="getAudioLengthSet"
              @timeupdate="audioTimeUpdateSet"
              @play="handPlaySet"
              @pause="handPauseSet"
              controls="controls"
              :volume="getMusicVolume"
              style="display: none"
            ></audio>
            <div>
              <el-slider
                :show-tooltip="false"
                v-model="musics.currentTime"
                :max="musics.duration"
                @change="changeAudioTimeSet"
              ></el-slider>
            </div>
          </div>
          <div class="soundtrack-times">
            <!-- formatTime(musics.currentTime) +
              " / " + -->
            <span class="music-time-msg">{{
              formatTime(musics.duration)
            }}</span>
          </div>
        </div>
        <div style="text-align: left">
          <span
            class="iconfont soundDown"
            @click="endWeakening"
            :class="[
              getSelectMusic.endEffect == 2 ? 'icon39121_1' : 'icon3912',
            ]"
          ></span>
          <span class="endStronger" style="font-size: '12px'">结尾渐弱</span>
        </div>
      </div>
      <div class="soundtrack-btn">
        <div class="soundtrack-btn-2">
          <el-button
            size="small"
            @click="replaceMusic(getSelectMusic, 'bgm', getMusicIndex)"
            class="replace-btn"
            >替换</el-button
          >
          <el-button size="small" class="clip-btn" @click="showClip"
            >剪辑</el-button
          >
        </div>
        <div>
          <el-button
            size="small"
            @click="showDeleteDialog()"
            class="soundtrack-delete"
            >删除</el-button
          >
        </div>
      </div>
    </div>
    <div v-show="!getSelectMusic" style="height: 100%; position: relative">
      <p class="noMUsic">未选中任何元素</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import audioPlay from "@/components/emodal/templateLib/contents/audioPlay.vue";
export default {
  mixins: [audioPlay],
  components: {},
  data() {
    return {
      favoritesState: null,
      musics: {
        isPlay: false,
        duration: 0, //标记时间戳
        currentTime: 0, //当前播放时间
      },
      duration: "", //作为字段传后台的时长
    };
  },
  computed: {
    ...mapGetters({
      getPlayHandle: "addSoundtrack/getPlayHandle",
      getSelectMusic: "addSoundtrack/getSelectMusic",
      getMusicIndex: "addSoundtrack/getMusicIndex",
      getMusicVolume: "addSoundtrack/getMusicVolume",
      getMusicArr: "addSoundtrack/getMusicArr",
      getSoundtrackState: "addSoundtrack/getSoundtrackState",
    }),
  },
  watch: {
    "musics.currentTime": {
      handler: function (val) {
        if (val == this.musics.duration) {
          //监听当前音频播放完之后会到起点
          this.musics.currentTime = 0;
          this.$refs.audioSet.pause();
          this.$refs.audioSet.currentTime = this.getSelectMusic.cut[0];
        }
      },
    },
    getSelectMusic(val) {
      //选择的音乐变了就暂停
      if (val) {
        this.musics = {
          isPlay: false,
          duration: 0, //标记时间戳
          currentTime: 0, //当前播放时间
        };
        if (this.$refs.audioSet) {
          this.remarkAudio();
        }
      }
    },
  },
  created() {},
  mounted() {
    this.$bus.on("replace_current_music", (state) => {
      //替换音频or剪辑之后重新获取音频中cut的数据
      this.getAudioLengthSet();
      this.musics.currentTime = 0;
    });
  },
  methods: {
    remarkAudio() {
      //重启当前音频
      this.getAudioLengthSet();
      this.$refs.audioSet.pause();
      this.$refs.audioSet.currentTime = this.getSelectMusic.cut[0];
    },

    // 收藏音乐
    async favoriteItem(item) {
      let postBody = {
        fileType: item.fileType || 14,
        id: item.id,
        url: item.url,
        title: item.title,
        duration: this.duration,
      };
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.favoritesState = true;
          this.$message({
            message: "收藏成功",
            type: "success",
            // duration: "1500",
          });
        } else if (res.data.code == 412) {
          this.favoritesState = true;
          this.$message({
            message: res.data.msg,
            type: "info",
            // duration: "1500",
          });
        }
      });
    },
    loopAction() {
      let oldMusics = this.getMusicArr.slice(0);
      this.$store.commit("addSoundtrack/setLoopSoundtrackAction", {
        type: "open",
      });
      this.$message({
        message: "配乐循环设置成功",
        type: "success",
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "loopMusic",
        data: {
          musics: this.getMusicArr.slice(0),
          oldMusics,
        },
      });
    },
    loopSoundTrack() {
      if (this.getMusicArr.length > 1) {
        this.$modal.show(
          "SubtitleMessageDialog",
          {
            view: "Common",
            textAlign: "left",
            msg: `当前配乐轴上有多首配乐，若开启配乐循环将自动清除其他配乐，是否确定开启配乐循环？`,
            resultCallback: (value) => {
              if (value && value.type === "Ok") {
                this.loopAction();
              }
            },
          },
          {
            width: "748px",
            height: "auto",
          }
        );
      } else {
        this.loopAction();
      }
    },
    remarkAudio() {
      //重启当前音频
      this.getAudioLengthSet();
      this.$refs.audioSet.pause();
      this.$refs.audioSet.currentTime = this.getSelectMusic.cut[0];
    },
    endWeakening() {
      let effect = this.getSelectMusic.endEffect == 0 ? 2 : 0;
      this.$store.commit("addSoundtrack/updateMusic", {
        music: {
          endEffect: effect,
        },
      });
    },
    // 拖动条
    changeAudioTimeSet(val) {
      if (this.$refs.audioSet) {
        this.$refs.audioSet.currentTime = val + this.getSelectMusic.cut[0];
      }
    },
    getAudioLengthSet() {
      console.log("this.getSelectMusic===>", this.getSelectMusic);
      if (this.getSelectMusic) {
        this.duration = this.$refs.audioSet.duration;
        this.musics.duration =
          this.getSelectMusic.cut[1] - this.getSelectMusic.cut[0];
      }
    },
    handPlaySet: function () {
      this.musics.isPlay = true;
      this.$refs.audioSet.currentTime =
        this.musics.currentTime + this.getSelectMusic.cut[0];
    },
    handPauseSet: function () {
      this.musics.isPlay = false;
      if (this.$refs.audioSet.ended) {
        this.musics.currentTime = 0;
      }
    },
    musicPlaySet: function () {
      if (!this.musics.isPlay) {
        this.$refs.audioSet.play();
      } else {
        this.$refs.audioSet.pause();
      }
    },
    audioTimeUpdateSet() {
      let time = this.$refs.audioSet.currentTime;
      if (time - this.musics.currentTime > 1) {
        this.musics.currentTime =
          parseFloat(time) - parseFloat(this.getSelectMusic.cut[0]);
      }
    },
    showDeleteDialog() {
      let that = this;
      this.$refs.audioSet.pause();
      this.$modal.show("SubtitleMessageDialog", {
        view: "Common",
        msg: "确认要删除该配乐文案吗?",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            that.deleteSoundtrack();
            if (that.getPlayHandle.musicLoop) {
              that.$store.commit(
                "addSoundtrack/setLoopSoundtrackStatus",
                false
              );
            }
          }
        },
      });
    },
    // 删除选中的配乐
    deleteSoundtrack() {
      let data = {
        index: this.getMusicIndex,
        data: JSON.stringify(
          Object.assign({}, this.getSelectMusic, {
            load: false,
            ele: null,
            playing: false,
          })
        ),
      };
      this.$store.commit("addSoundtrack/delMusic", this.getMusicIndex);
      this.$bus.emit("insert_subtitle_undo", {
        type: "delMusic",
        data: data,
      });
    },
    showClip() {
      this.$refs.audioSet.pause();
      if (parseInt(this.$refs.audioSet.duration) <= 1) {
        return this.$message("视频时长小于两秒不支持剪辑");
      }
      this.$store.commit("soundtrackSet/setsoundtrackClipState", true);
      this.$store.commit("soundtrackSet/setCutMusic", this.getSelectMusic);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./common.scss";
.soundDown {
  font-size: 14px;
  margin-right: 8px;
}
.soundtrack-container .soundtrack-item-name {
  display: flex;
  justify-content: space-between;
}
.endStronger {
  color: #474261;
  font-size: 12px;
}
.current-music-title {
  width: calc(100% - 60px);
}
.collection {
  cursor: pointer;
  line-height: 24px;
  width: 50px;
  height: 24px;
  background: #f0f0f8;
  border-radius: 4px;
  padding: 0 4px;
  border: inherit;
  font-size: 12px;
}
.iconshoucang1 {
  font-size: 12px;
  display: inline-block;
  transform: scale(0.8);
  color: #737596;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/soundtrack/soundtrackSet.vue